// /*
//   Shopify Product Custom Options JS
//   Shella 6.6.0 Compatible
//   File: assets/custom-options.js

//   =============================================
//   HOW TO SET OPTIONS PER PRODUCT (Metafields)
//   =============================================
  
//   Go to: Shopify Admin > Products > [Your Product] > Metafields
//   Namespace: custom
//   Key: product_options
//   Type: JSON

//   Example JSON for a T-Shirt:
//   [
//     {
//       "id": "size",
//       "name": "Size",
//       "type": "dropdown",
//       "required": true,
//       "values": [
//         { "label": "Small", "price": 0 },
//         { "label": "Medium", "price": 0 },
//         { "label": "Large", "price": 200 },
//         { "label": "XL", "price": 200 },
//         { "label": "XXL", "price": 400 }
//       ]
//     },
//     {
//       "id": "color",
//       "name": "Color",
//       "type": "buttons",
//       "required": true,
//       "values": [
//         { "label": "White", "price": 0 },
//         { "label": "Black", "price": 0 },
//         { "label": "Navy", "price": 100 }
//       ]
//     },
//     {
//       "id": "embroidery",
//       "name": "Embroidery Text",
//       "type": "text",
//       "required": false,
//       "placeholder": "Enter text to embroider",
//       "price": 500,
//       "condition": {
//         "option_id": "size",
//         "value": "Large"
//       }
//     }
//   ]

//   OPTION TYPES:
//   - "dropdown"  : select dropdown
//   - "buttons"   : clickable button swatches
//   - "radio"     : radio buttons
//   - "text"      : free text input
//   - "checkbox"  : multiple checkboxes

//   CONDITION (optional):
//   Show this option only when another option has a specific value.
//   {
//     "condition": {
//       "option_id": "size",    <- id of the parent option
//       "value": "Large"        <- value that triggers this option
//     }
//   }

//   PRICE:
//   - For dropdown/buttons/radio/checkbox: set "price" on each value
//   - For text input: set "price" on the option itself (flat fee)
//   - Price is in subunits (paise) — Rs.500 = 50000 ... 
//     WAIT: Shopify stores prices in cents/paise
//     For PKR: Rs.500 = 50000? No — Shopify PKR = no decimals, so Rs.500 = 500
//     Just enter the rupee amount directly e.g. 500 for Rs.500
// */

// (function () {
//   'use strict';

//   // ─── State ────────────────────────────────────────────────────────────────
//   const productStates = {};

//   // ─── Init ─────────────────────────────────────────────────────────────────
//   function init() {
//     document.querySelectorAll('.custom-options-wrapper').forEach(wrapper => {
//       const productId = wrapper.dataset.productId;
//       const basePrice = parseInt(wrapper.dataset.basePrice, 10) || 0;

//       let optionsData = [];
//       try {
//         optionsData = JSON.parse(wrapper.dataset.options || '[]');
//       } catch (e) {
//         console.warn('[CustomOptions] Invalid JSON for product', productId);
//         return;
//       }

//       productStates[productId] = {
//         basePrice,
//         selections: {},
//         options: optionsData
//       };

//       bindEvents(wrapper, productId);
//       evaluateConditions(wrapper, productId);
//     });

//     // Intercept add-to-cart
//     interceptAddToCart();
//   }

//   // ─── Bind Events ──────────────────────────────────────────────────────────
//   function bindEvents(wrapper, productId) {
//     // Dropdown
//     wrapper.querySelectorAll('.custom-option-select').forEach(select => {
//       select.addEventListener('change', function () {
//         const optId = this.dataset.optionId;
//         const optName = this.dataset.optionName;
//         const selected = this.options[this.selectedIndex];
//         const price = parseInt(selected.dataset.price || '0', 10);
//         const value = this.value;

//         updateSelection(productId, optId, optName, value, price);
//         evaluateConditions(wrapper, productId);
//         updatePriceSummary(wrapper, productId);
//       });
//     });

//     // Buttons
//     wrapper.querySelectorAll('.custom-option-btn').forEach(btn => {
//       btn.addEventListener('click', function () {
//         const optId = this.dataset.optionId;
//         const optName = this.dataset.optionName;
//         const price = parseInt(this.dataset.price || '0', 10);
//         const value = this.dataset.value;

//         // Deselect siblings
//         wrapper.querySelectorAll(`.custom-option-btn[data-option-id="${optId}"]`).forEach(b => {
//           b.classList.remove('selected');
//         });
//         this.classList.add('selected');

//         updateSelection(productId, optId, optName, value, price);
//         evaluateConditions(wrapper, productId);
//         updatePriceSummary(wrapper, productId);
//       });
//     });

//     // Radio
//     wrapper.querySelectorAll('input[type="radio"]').forEach(radio => {
//       radio.addEventListener('change', function () {
//         const optId = this.dataset.optionId;
//         const optName = this.dataset.optionName;
//         const price = parseInt(this.dataset.price || '0', 10);
//         const value = this.value;

//         updateSelection(productId, optId, optName, value, price);
//         evaluateConditions(wrapper, productId);
//         updatePriceSummary(wrapper, productId);
//       });
//     });

//     // Text
//     wrapper.querySelectorAll('.custom-option-text').forEach(input => {
//       input.addEventListener('input', function () {
//         const optId = this.dataset.optionId;
//         const optName = this.dataset.optionName;
//         const price = parseInt(this.dataset.price || '0', 10);
//         const value = this.value.trim();

//         updateSelection(productId, optId, optName, value, value ? price : 0);
//         updatePriceSummary(wrapper, productId);
//       });
//     });

//     // Checkbox
//     wrapper.querySelectorAll('.custom-option-checkbox').forEach(cb => {
//       cb.addEventListener('change', function () {
//         const optId = this.dataset.optionId;
//         const optName = this.dataset.optionName;

//         // Collect all checked values for this option
//         const checkedBoxes = wrapper.querySelectorAll(
//           `.custom-option-checkbox[data-option-id="${optId}"]:checked`
//         );
//         const labels = [];
//         let totalPrice = 0;
//         checkedBoxes.forEach(box => {
//           labels.push(box.value);
//           totalPrice += parseInt(box.dataset.price || '0', 10);
//         });

//         updateSelection(productId, optId, optName, labels.join(', '), totalPrice);
//         updatePriceSummary(wrapper, productId);
//       });
//     });
//   }

//   // ─── Update Selection ─────────────────────────────────────────────────────
//   function updateSelection(productId, optId, optName, value, price) {
//     const state = productStates[productId];
//     if (!state) return;

//     if (value === '' || value === null) {
//       delete state.selections[optId];
//     } else {
//       state.selections[optId] = { name: optName, value, price };
//     }
//   }

//   // ─── Conditional Logic ────────────────────────────────────────────────────
//   function evaluateConditions(wrapper, productId) {
//     const state = productStates[productId];
//     if (!state) return;

//     wrapper.querySelectorAll('.custom-option-group[data-condition-option]').forEach(group => {
//       const condOptId = group.dataset.conditionOption;
//       const condVal = group.dataset.conditionValue;
//       const currentSel = state.selections[condOptId];
//       const currentVal = currentSel ? currentSel.value : '';

//       const shouldShow = currentVal === condVal;
//       group.style.display = shouldShow ? '' : 'none';

//       // Clear hidden option's selection
//       if (!shouldShow) {
//         const optId = group.dataset.optionId;
//         delete state.selections[optId];
//         // Reset inputs inside
//         group.querySelectorAll('select').forEach(s => s.selectedIndex = 0);
//         group.querySelectorAll('.custom-option-btn').forEach(b => b.classList.remove('selected'));
//         group.querySelectorAll('input[type="radio"]').forEach(r => r.checked = false);
//         group.querySelectorAll('.custom-option-text').forEach(t => t.value = '');
//         group.querySelectorAll('.custom-option-checkbox').forEach(c => c.checked = false);
//       }
//     });
//   }

//   // ─── Price Summary ────────────────────────────────────────────────────────
//   function updatePriceSummary(wrapper, productId) {
//     const state = productStates[productId];
//     if (!state) return;

//     let addonTotal = 0;
//     Object.values(state.selections).forEach(sel => {
//       addonTotal += sel.price || 0;
//     });

//     const summaryEl = document.getElementById(`price-summary-${productId}`);
//     const addonEl = document.getElementById(`addon-price-${productId}`);

//     if (summaryEl && addonEl) {
//       if (addonTotal > 0) {
//         summaryEl.style.display = '';
//         addonEl.textContent = '+' + formatMoney(addonTotal);
//       } else {
//         summaryEl.style.display = 'none';
//       }
//     }

//     // Update main price display (Shella uses .price__current or .product__price)
//     updateMainPrice(productId, state.basePrice + addonTotal);
//   }

//   function updateMainPrice(productId, totalPrice) {
//     // Shella theme price selectors — covers most Shella versions
//     const selectors = [
//       '.product__price .price__current',
//       '.product__price .money',
//       '.price--on-sale .price__regular .money',
//       '[data-product-price]',
//       '.product-single__price .money'
//     ];

//     selectors.forEach(sel => {
//       const el = document.querySelector(sel);
//       if (el) el.textContent = formatMoney(totalPrice);
//     });
//   }

//   // ─── Cart Intercept ───────────────────────────────────────────────────────
//   function interceptAddToCart() {
//     // Shella uses form with action="/cart/add" or data-product-form
//     document.querySelectorAll('form[action="/cart/add"], [data-product-form]').forEach(form => {
//       form.addEventListener('submit', function (e) {
//         const wrapper = document.querySelector('.custom-options-wrapper');
//         if (!wrapper) return;

//         const productId = wrapper.dataset.productId;
//         const state = productStates[productId];
//         if (!state) return;

//         // Validate required options
//         const isValid = validateRequired(wrapper, productId);
//         if (!isValid) {
//           e.preventDefault();
//           e.stopImmediatePropagation();
//           const errorEl = document.getElementById(`options-error-${productId}`);
//           if (errorEl) {
//             errorEl.style.display = '';
//             errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
//           }
//           return;
//         }

//         // Hide error if shown
//         const errorEl = document.getElementById(`options-error-${productId}`);
//         if (errorEl) errorEl.style.display = 'none';

//         // Add selections as line item properties (hidden inputs)
//         removeOldCustomInputs(form);
//         Object.values(state.selections).forEach(sel => {
//           if (!sel.value) return;
//           const input = document.createElement('input');
//           input.type = 'hidden';
//           input.name = `properties[${sel.name}]`;
//           input.value = sel.value;
//           form.appendChild(input);
//         });

//         // If price addon exists, update variant price via URL or note
//         // (Shopify free plan: we store price note as property)
//         const addonTotal = Object.values(state.selections).reduce((sum, s) => sum + (s.price || 0), 0);
//         if (addonTotal > 0) {
//           const priceInput = document.createElement('input');
//           priceInput.type = 'hidden';
//           priceInput.name = 'properties[Price Add-on]';
//           priceInput.value = formatMoney(addonTotal);
//           form.appendChild(priceInput);
//         }
//       });
//     });
//   }

//   // ─── Validation ───────────────────────────────────────────────────────────
//   function validateRequired(wrapper, productId) {
//     const state = productStates[productId];
//     let valid = true;

//     state.options.forEach(opt => {
//       if (!opt.required) return;

//       // Skip if hidden by condition
//       const group = wrapper.querySelector(`.custom-option-group[data-option-id="${opt.id}"]`);
//       if (group && group.style.display === 'none') return;

//       const sel = state.selections[opt.id];
//       if (!sel || !sel.value) valid = false;
//     });

//     return valid;
//   }

//   // ─── Helpers ──────────────────────────────────────────────────────────────
//   function formatMoney(amount) {
//     // PKR format — adjust if needed
//     return 'Rs. ' + Math.round(amount).toLocaleString();
//   }

//   function removeOldCustomInputs(form) {
//     form.querySelectorAll('input[name^="properties["]').forEach(el => el.remove());
//   }

//   // ─── Run ──────────────────────────────────────────────────────────────────
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

// })();


/*
 * Shopify Product Custom Options JS
 * Optimized for Shella 6.6.0
 */

(function () {
  'use strict';

  var productStates = Object.create(null);

  // ---------------------------------------------------------------------------
  // INIT
  // ---------------------------------------------------------------------------

  function init() {
    var wrappers = document.querySelectorAll('.custom-options-wrapper');

    if (!wrappers.length) {
      return;
    }

    wrappers.forEach(function (wrapper) {
      initWrapper(wrapper);
    });

    interceptAddToCart();
  }

  function initWrapper(wrapper) {
    var productId = wrapper.dataset.productId;

    if (!productId) {
      return;
    }

    var basePrice = parseInt(wrapper.dataset.basePrice, 10) || 0;
    var optionsData = [];

    try {
      optionsData = JSON.parse(wrapper.dataset.options || '[]');
    } catch (error) {
      console.warn(
        '[CustomOptions] Invalid JSON for product:',
        productId
      );
      return;
    }

    var state = {
      wrapper: wrapper,
      basePrice: basePrice,
      selections: Object.create(null),
      options: optionsData,

      // Cache frequently accessed elements.
      priceSummary: wrapper.querySelector(
        '#price-summary-' + productId
      ),

      addonPrice: wrapper.querySelector(
        '#addon-price-' + productId
      ),

      priceElements: getPriceElements()
    };

    productStates[productId] = state;

    bindEvents(wrapper, productId);
    evaluateConditions(wrapper, productId);
    updatePriceSummary(productId);
  }

  // ---------------------------------------------------------------------------
  // EVENT BINDING
  // ---------------------------------------------------------------------------

  function bindEvents(wrapper, productId) {
    /*
     * Event delegation means we don't need one listener per control.
     *
     * This is especially useful when a product has many option values.
     */
    wrapper.addEventListener('change', function (event) {
      var target = event.target;

      if (
        target.matches('.custom-option-select') ||
        target.matches('input[type="radio"]')
      ) {
        handleSingleValueChange(target, productId);
        return;
      }

      if (target.matches('.custom-option-checkbox')) {
        handleCheckboxChange(target, productId);
      }
    });

    wrapper.addEventListener('click', function (event) {
      var button = event.target.closest('.custom-option-btn');

      if (!button || !wrapper.contains(button)) {
        return;
      }

      handleButtonChange(button, wrapper, productId);
    });

    /*
     * Text inputs use a small debounce.
     *
     * Without this, every keystroke causes price/state/DOM work.
     */
    var textTimer = null;

    wrapper.addEventListener('input', function (event) {
      var input = event.target;

      if (!input.matches('.custom-option-text')) {
        return;
      }

      window.clearTimeout(textTimer);

      textTimer = window.setTimeout(function () {
        handleTextChange(input, productId);
      }, 120);
    });
  }

  // ---------------------------------------------------------------------------
  // SELECT / RADIO
  // ---------------------------------------------------------------------------

  function handleSingleValueChange(element, productId) {
    var optId = element.dataset.optionId;
    var optName = element.dataset.optionName;

    var value = element.value;
    var price = 0;

    if (element.matches('.custom-option-select')) {
      var selectedOption =
        element.options[element.selectedIndex];

      price = parseInt(
        selectedOption &&
          selectedOption.dataset.price
          ? selectedOption.dataset.price
          : '0',
        10
      );
    } else {
      price = parseInt(
        element.dataset.price || '0',
        10
      );
    }

    updateSelection(
      productId,
      optId,
      optName,
      value,
      price
    );

    evaluateConditions(productId);
    updatePriceSummary(productId);
  }

  // ---------------------------------------------------------------------------
  // BUTTON
  // ---------------------------------------------------------------------------

  function handleButtonChange(button, wrapper, productId) {
    var optId = button.dataset.optionId;
    var optName = button.dataset.optionName;
    var value = button.dataset.value;
    var price = parseInt(
      button.dataset.price || '0',
      10
    );

    /*
     * Instead of querySelectorAll(), only remove the
     * selected class from buttons belonging to this option.
     */
    var buttons = wrapper.querySelectorAll(
      '.custom-option-btn[data-option-id="' +
      escapeSelectorValue(optId) +
      '"]'
    );

    buttons.forEach(function (item) {
      item.classList.remove('selected');
    });

    button.classList.add('selected');

    updateSelection(
      productId,
      optId,
      optName,
      value,
      price
    );

    evaluateConditions(productId);
    updatePriceSummary(productId);
  }

  // ---------------------------------------------------------------------------
  // TEXT
  // ---------------------------------------------------------------------------

  function handleTextChange(input, productId) {
    var optId = input.dataset.optionId;
    var optName = input.dataset.optionName;

    var value = input.value.trim();

    var price = parseInt(
      input.dataset.price || '0',
      10
    );

    updateSelection(
      productId,
      optId,
      optName,
      value,
      value ? price : 0
    );

    updatePriceSummary(productId);
  }

  // ---------------------------------------------------------------------------
  // CHECKBOX
  // ---------------------------------------------------------------------------

  function handleCheckboxChange(checkbox, productId) {
    var wrapper = productStates[productId].wrapper;
    var optId = checkbox.dataset.optionId;
    var optName = checkbox.dataset.optionName;

    var selector =
      '.custom-option-checkbox[data-option-id="' +
      escapeSelectorValue(optId) +
      '"]:checked';

    var checkedBoxes = wrapper.querySelectorAll(selector);

    var labels = [];
    var totalPrice = 0;

    checkedBoxes.forEach(function (box) {
      labels.push(box.value);

      totalPrice += parseInt(
        box.dataset.price || '0',
        10
      );
    });

    updateSelection(
      productId,
      optId,
      optName,
      labels.join(', '),
      totalPrice
    );

    updatePriceSummary(productId);
  }

  // ---------------------------------------------------------------------------
  // STATE
  // ---------------------------------------------------------------------------

  function updateSelection(
    productId,
    optId,
    optName,
    value,
    price
  ) {
    var state = productStates[productId];

    if (!state) {
      return;
    }

    if (value === '' || value === null) {
      delete state.selections[optId];
      return;
    }

    state.selections[optId] = {
      name: optName,
      value: value,
      price: price || 0
    };
  }

  // ---------------------------------------------------------------------------
  // CONDITIONAL OPTIONS
  // ---------------------------------------------------------------------------

  function evaluateConditions(productId) {
    var state = productStates[productId];

    if (!state) {
      return;
    }

    var wrapper = state.wrapper;

    wrapper
      .querySelectorAll(
        '.custom-option-group[data-condition-option]'
      )
      .forEach(function (group) {
        var conditionOption =
          group.dataset.conditionOption;

        var conditionValue =
          group.dataset.conditionValue;

        var currentSelection =
          state.selections[conditionOption];

        var currentValue =
          currentSelection
            ? currentSelection.value
            : '';

        var shouldShow =
          currentValue === conditionValue;

        var isCurrentlyHidden =
          group.style.display === 'none';

        if (shouldShow) {
          if (isCurrentlyHidden) {
            group.style.display = '';
          }

          return;
        }

        /*
         * Avoid repeatedly touching the DOM if the group
         * is already hidden.
         */
        if (!isCurrentlyHidden) {
          group.style.display = 'none';
        }

        var optionId = group.dataset.optionId;

        delete state.selections[optionId];

        resetGroup(group);
      });
  }

  function resetGroup(group) {
    /*
     * Only reset controls that currently have a value.
     */
    group
      .querySelectorAll('select')
      .forEach(function (select) {
        if (select.selectedIndex !== 0) {
          select.selectedIndex = 0;
        }
      });

    group
      .querySelectorAll('.custom-option-btn.selected')
      .forEach(function (button) {
        button.classList.remove('selected');
      });

    group
      .querySelectorAll(
        'input[type="radio"]:checked'
      )
      .forEach(function (radio) {
        radio.checked = false;
      });

    group
      .querySelectorAll('.custom-option-text')
      .forEach(function (input) {
        if (input.value) {
          input.value = '';
        }
      });

    group
      .querySelectorAll(
        '.custom-option-checkbox:checked'
      )
      .forEach(function (checkbox) {
        checkbox.checked = false;
      });
  }

  // ---------------------------------------------------------------------------
  // PRICE
  // ---------------------------------------------------------------------------

  function updatePriceSummary(productId) {
    var state = productStates[productId];

    if (!state) {
      return;
    }

    var addonTotal = 0;

    Object.keys(state.selections).forEach(function (key) {
      var selection = state.selections[key];

      addonTotal += selection.price || 0;
    });

    var summaryEl = state.priceSummary;
    var addonEl = state.addonPrice;

    if (summaryEl && addonEl) {
      if (addonTotal > 0) {
        summaryEl.style.display = '';
        addonEl.textContent =
          '+' + formatMoney(addonTotal);
      } else {
        summaryEl.style.display = 'none';
      }
    }

    updateMainPrice(
      state,
      state.basePrice + addonTotal
    );
  }

  function updateMainPrice(state, totalPrice) {
    var formattedPrice =
      formatMoney(totalPrice);

    state.priceElements.forEach(function (element) {
      element.textContent = formattedPrice;
    });
  }

  function getPriceElements() {
    var selectors = [
      '.product__price .price__current',
      '.product__price .money',
      '.price--on-sale .price__regular .money',
      '[data-product-price]',
      '.product-single__price .money'
    ];

    var elements = [];

    selectors.forEach(function (selector) {
      document
        .querySelectorAll(selector)
        .forEach(function (element) {
          if (elements.indexOf(element) === -1) {
            elements.push(element);
          }
        });
    });

    return elements;
  }

  // ---------------------------------------------------------------------------
  // ADD TO CART
  // ---------------------------------------------------------------------------

  function interceptAddToCart() {
    /*
     * Use event delegation instead of attaching a listener
     * to every product form.
     */
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;

        if (
          !form.matches(
            'form[action="/cart/add"], [data-product-form]'
          )
        ) {
          return;
        }

  //       var wrapper =
  // form.closest(
  //   '.product, .product-page, body'
  // ) &&
  // document.querySelector(
  //   '.custom-options-wrapper'
  // );

        var wrapper = form.closest('.product, .product-page');

        if (!wrapper) {
          wrapper = document.querySelector('.custom-options-wrapper');
        }

        if (!wrapper) {
          return;
        }

        var productId =
          wrapper.dataset.productId;

        var state =
          productStates[productId];

        if (!state) {
          return;
        }

        var isValid =
          validateRequired(
            wrapper,
            productId
          );

        if (!isValid) {
          event.preventDefault();
          event.stopImmediatePropagation();

          var errorEl =
            document.getElementById(
              'options-error-' + productId
            );

          if (errorEl) {
            errorEl.style.display = '';

            /*
             * Avoid smooth scrolling here.
             *
             * Smooth scrolling can add unnecessary animation
             * work during an interaction.
             */
            errorEl.scrollIntoView({
              behavior: 'auto',
              block: 'nearest'
            });
          }

          return;
        }

        var errorEl =
          document.getElementById(
            'options-error-' + productId
          );

        if (errorEl) {
          errorEl.style.display = 'none';
        }

        removeOldCustomInputs(form);

        Object.keys(state.selections).forEach(
          function (key) {
            var selection =
              state.selections[key];

            if (!selection.value) {
              return;
            }

            var input =
              document.createElement('input');

            input.type = 'hidden';
            input.name =
              'properties[' +
              selection.name +
              ']';

            input.value =
              selection.value;

            form.appendChild(input);
          }
        );

        var addonTotal = 0;

        Object.keys(state.selections).forEach(
          function (key) {
            addonTotal +=
              state.selections[key].price || 0;
          }
        );

        if (addonTotal > 0) {
          var priceInput =
            document.createElement('input');

          priceInput.type = 'hidden';
          priceInput.name =
            'properties[Price Add-on]';

          priceInput.value =
            formatMoney(addonTotal);

          form.appendChild(priceInput);
        }
      },
      true
    );
  }

  // ---------------------------------------------------------------------------
  // VALIDATION
  // ---------------------------------------------------------------------------

  function validateRequired(
    wrapper,
    productId
  ) {
    var state =
      productStates[productId];

    if (!state) {
      return true;
    }

    for (
      var i = 0;
      i < state.options.length;
      i++
    ) {
      var option =
        state.options[i];

      if (!option.required) {
        continue;
      }

      var group =
        wrapper.querySelector(
          '.custom-option-group[data-option-id="' +
          escapeSelectorValue(option.id) +
          '"]'
        );

      if (
        group &&
        group.style.display === 'none'
      ) {
        continue;
      }

      var selection =
        state.selections[option.id];

      if (
        !selection ||
        !selection.value
      ) {
        return false;
      }
    }

    return true;
  }

  // ---------------------------------------------------------------------------
  // HELPERS
  // ---------------------------------------------------------------------------

  function formatMoney(amount) {
    return (
      'Rs. ' +
      Math.round(amount).toLocaleString()
    );
  }

  function removeOldCustomInputs(form) {
    form
      .querySelectorAll(
        'input[name^="properties["]'
      )
      .forEach(function (input) {
        input.remove();
      });
  }

  function escapeSelectorValue(value) {
    if (
      window.CSS &&
      typeof window.CSS.escape === 'function'
    ) {
      return window.CSS.escape(value);
    }

    return String(value).replace(
      /([^\w-])/g,
      '\\$1'
    );
  }

  // ---------------------------------------------------------------------------
  // START
  // ---------------------------------------------------------------------------

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }

})();